import React, { useState } from "react";

import { IAccordionItem } from "../../types/IAccordionItem";
import { IContentfulBackgroundColour } from "../../types/IContentfulBackgroundColour";
import { Heading } from "../Heading";

import { RichText } from "../RichText";
import "./styles.scss";
import { GatsbyImageOrSvg } from "../../utils/GatsbyImageOrSvg/GatsbyImageOrSvg";

interface IProps {
  backgroundColour: IContentfulBackgroundColour;
  data: IAccordionItem[];
}

const ContentWithSidebar = ({ backgroundColour, data }: IProps) => {
  const [selectedItem, setSelectedItem] = useState(data[0]);
  const { content, image, secondaryTitle } = selectedItem;
  return (
    <div className="contentWithSidebar">
      <div className="contentWithSidebar__sidebar">
        {data.map((item, index) => {
          const active = item === selectedItem;
          return (
            <div
              tabIndex={0}
              key={index}
              className="contentWithSidebar__title-container"
              onClick={() => setSelectedItem(item)}
              onKeyPress={() => setSelectedItem(item)}
              role="button"
            >
              <Heading
                className="contentWithSidebar__title"
                type={item.headingType || "h3"}
                id={`content-with-sidebar-title-${index}`}
              >
                {item.title}
              </Heading>
              {active && <span className="contentWithSidebar__arrow-icon" />}
            </div>
          );
        })}
      </div>
      <div
        className={`contentWithSidebar__content contentWithSidebar__content--background-${backgroundColour}`}
      >
        {image && (
          <div className="contentWithSidebar__imageContainer">
            <GatsbyImageOrSvg image={image} loading="lazy" alt={image.title} className="contentWithSidebar__image" />
          </div>
        )}
        {secondaryTitle && (
          <h3 className="contentWithSidebar__title">{secondaryTitle}</h3>
        )}
        <RichText
          contrastText={false}
          className="contentWithSidebar__text"
          content={content}
        />
      </div>
    </div>
  );
};

export { ContentWithSidebar, IProps };
